import { api } from "@/lib/api-client";
import type { Paginated } from "../agents/api";

export type Notification = {
  id: string;
  title: string;
  message: string;
  is_read: boolean;
  created_at: string;
  notification_type?: string;
};

export const notificationsApi = {
  list: async () => {
    const res = await api.get<Paginated<Notification> | Notification[]>(
      "/notifications/",
    );
    return Array.isArray(res.data) ? res.data : res.data.results;
  },

  unreadCount: async () => {
    const res = await api.get<{ count: number }>("/notifications/unread_count/");
    return res.data.count;
  },

  markRead: async (id: string) => {
    await api.post(`/notifications/${id}/mark_read/`);
  },

  markAllRead: async () => {
    await api.post("/notifications/mark_all_read/");
  },
};
